import { AxisRendererX } from "@amcharts/amcharts5/xy";

import StackedColumnLineChart from "@/classes/StackedColumnLineChart";
import { stringOrNumberToDate } from "@/helpers/formatters";
import { ChartDataRecord } from "@/types/charts";

export default class StackedColumnLineTimeChart extends StackedColumnLineChart {
  protected createAxes(): void {
    super.createAxes();

    const formatter = this.formatters[this.settings.xAxis];
    if (!formatter) return;

    const renderer = this.xAxis.get("renderer") as AxisRendererX;
    renderer.labels.template.adapters.add("text", (text, target) => {
      const category = (target.dataItem as { get(key: string): unknown } | undefined)?.get("category") as
        | string
        | undefined;
      return category ? String(formatter(category)) : text;
    });
  }

  protected mapData(data: []): ChartDataRecord[] {
    const mapped = super.mapData(data);

    mapped.sort(
      (a, b) => stringOrNumberToDate(a.name as string).getTime() - stringOrNumberToDate(b.name as string).getTime()
    );

    this.names = mapped.map((row) => row.name as string);

    return mapped;
  }
}
